import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

import { setSolid } from 'redux/modules/navigation'

import BodyText from 'ui/components/modules/BodyText'
import ButtonModule from 'ui/components/modules/ButtonModule'
import ContactCards from 'ui/components/modules/ContactCards'
import Distance from 'ui/components/modules/Distance'
import Embed from 'ui/components/modules/Embed'
import FocusDonate from 'ui/components/modules/FocusDonate'
import FocusGrid from 'ui/components/modules/FocusGrid'
import Form from 'ui/components/modules/Form'
import Hero from 'ui/components/modules/Hero'
import Image from 'ui/components/modules/Image'
import Module from 'ui/components/Module'
import PageHeader from 'ui/components/modules/PageHeader'
import Quote from 'ui/components/modules/Quote'
import TextAndImage from 'ui/components/modules/TextAndImage'
import Video from 'ui/components/modules/Video'

const Wrapper = styled.div`
  background-color: ${props => props.theme.colors.background};
`;

const Missing = styled.div`
  padding: 30px;
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.tones.dark};
  font-size: 18px;
`

class Modules extends Component {

  componentDidUpdate() {
    this.updateNavColor()
  }

  componentDidMount() {
    this.updateNavColor()
  }

  updateNavColor() {
    const {
      modules,
      setNavSolid
    } = this.props

    switch (modules[0].layout) {
      case 'hero':
        setNavSolid(false)
        break

      default:
        setNavSolid(true)
        break
    }
  }

  getModules() {
    const { modules, post } = this.props

    return modules.map((module, index) => {
      const key = index + '-' + module.layout;
      switch (module.layout) {
        case 'hero':
          return <Hero {...module} />
        case 'pageHeader':
          return <PageHeader {...module} title={post.title} />
        case 'bodyText':
          return <BodyText {...module} />
        case 'quote':
          return <Quote {...module} />
        case 'image':
          return <Image {...module} />
        case 'embed':
          return <Embed {...module} />
        case 'form':
          return <Form {...module} />
        case 'distance':
          return <Distance {...module} />
        case 'textAndImage':
          return <TextAndImage {...module} />
        case 'focusGrid':
          return <FocusGrid {...module} />
        case 'video':
          return <Video {...module} />
        case 'focusDonate':
          return <FocusDonate {...module} />
        case 'button':
          return <ButtonModule {...module} />
        case 'contactCards':
          return <ContactCards {...module} />
        default:
          console.log(module)
          return <Missing key={key}>Missing implementation of {module.layout}</Missing>
      }
    });
  }

  render() {
    return (
      <Wrapper>
        {this.getModules().map((module, index) => <Module key={index} id={`module-${index}`}>{module}</Module>)}
      </Wrapper>
    );
  }
}

export default connect(null, { setNavSolid: setSolid })(Modules)



// WEBPACK FOOTER //
// ./src/ui/components/Modules.js